export default {
  table: {
    header: [
      { title: "#", id: "order" },
      { title: "รหัสวิชา", id: "subjectCode" },
      { title: "ชื่อวิชา", id: "subjectName" },
      { title: "อาจารย์", id: "teacher" },
      { title: "จำนวนข้อสอบ", id: "" },
      { title: " ", id: "actions" },
      { title: " ", id: "vdo-topic" }
    ]
  },
  list: [
    {
      subjectCode: "SUBJECT CODE",
      subjectName: "SUBJECT NAME",
      subjectGroup: "SUBJECT GROUP",
      teacher: { firstNameLocal: "FIRST NAME", lastNameLocal: "LAST NAME" }
    }
  ],
  form: {
    filter: {
      // academicPeriodId: "",
      // periodCode: "",
      degreeId: "",
      subjectGroupId: "",
      subjectId: "",
      // subjectCode: "",
      // subjectName: "",
      // courseOutlineId: "",
      teacherId: "",
      // teacherCode: "",
    },
    courseOutlineRegistrationInput: []
  }
};
